import { darken } from '@mui/material';
import { blue, pink } from '@mui/material/colors';
export const autoscan_colors = (dark) => ({
    primary: {
        main: dark ? blue[200] : blue[700],
    },
    secondary: {
        main: dark ? pink[200] : darken(pink.A400, 0.1),
    },
    //delete because autoscan auditory is very conservative
    // primary: {
    //     light: '#60dffd',
    //     main: '#05adca',
    //     dark: '#007d99',
    //     contrastText: '#0f0f0f',
    // },
    // secondary: {
    //     light: '#ff5c35',
    //     main: '#ca2305',
    //     dark: '#910000',
    //     contrastText: '#ffffff',
    // },
});
